import { Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useThemeContext from '../../../../contexts/theme';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { MappedReclamationType } from '../../types';
import { TableContainer } from './styles';

interface ITableView {
  filteredList: MappedReclamationType[];
  activeSidebar: string | null,
  returnLink: string | null,
}

export default function TableView({
  filteredList,
  activeSidebar,
  returnLink,
}: ITableView) {
  const navigate = useNavigate();
  const { selectedTheme } = useThemeContext();
  const { companyCode } = useGetGeneralAppData();

  return (
    <TableContainer>
      <Table responsive variant={selectedTheme === 'dark' ? 'dark' : ''} hover striped>
        <thead>
          <tr>
            <th>Consulta</th>
            <th>Cidade Residência</th>
            <th>Cidade Trabalho</th>
            <th>Data geração</th>
          </tr>
        </thead>
        <tbody>
          {filteredList.map((rcl) => (
            <tr key={rcl.consultCode + rcl.date + Math.random()}  onClick={() => navigate(`/consults/result/${rcl.consultCode}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar ?? 'Home'}&returnLink=${decodeURIComponent(returnLink ?? '/')}${rcl.routeType === 'MULTI ROTAS' ? '&mr' : ''}`)}>
              <td>
                {rcl.consultCode}
              </td>
              <td>
                {rcl.homeCity}
              </td>
              <td>
                {rcl.workCity}
              </td>
              <td>
                {rcl.date}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
}
